import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CatModal } from '@blocks-react/components/Modal';
import { CatButton } from '@blocks-react/components/Button';
import WrapperContainer from '@app/components/common/WrapperContainer';
import { BUTTON_SIZES, BUTTON_VARIANTS } from '@app/constants/commonConstants';
import { MODALS_ROOT } from '@app/constants/targets';
import styles from './ConfirmationModal.module.scss';

const ConfirmationModal = ({
  heading,
  message,
  isOpen,
  onConfirm,
  onClose,
  buttonOptions
}) => {
  const {
    primaryButtonText,
    primaryButtonVariant = BUTTON_VARIANTS.PRIMARY,
    primaryButtonIcon,
    secondaryButtonText,
    secondaryButtonVariant = BUTTON_VARIANTS.GHOST
  } = buttonOptions;

  const [t] = useTranslation();

  return (
    <WrapperContainer targetId={MODALS_ROOT}>
      <CatModal
        isActive={isOpen}
        closeModal={onClose}
        heading={heading}
        className={`${styles['confirmation-modal__container']}`}
      >
        <span className="cat-u-theme-typography-body-sm">{message}</span>
        <div slot="footer">
          <CatButton
            variant={primaryButtonVariant}
            size={BUTTON_SIZES.SM}
            onClick={onConfirm}
          >
            {primaryButtonIcon || null}
            <span>{primaryButtonText || t('YES')}</span>
          </CatButton>
          <CatButton
            variant={secondaryButtonVariant}
            size={BUTTON_SIZES.SM}
            onClick={onClose}
            className="ps-3"
          >
            <span>{secondaryButtonText || t('NO')}</span>
          </CatButton>
        </div>
      </CatModal>
    </WrapperContainer>
  );
};

export default ConfirmationModal;

ConfirmationModal.propTypes = {
  heading: PropTypes.string,
  message: PropTypes.string,
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  buttonOptions: PropTypes.shape({
    primaryButtonText: PropTypes.string,
    primaryButtonVariant: PropTypes.string,
    primaryButtonIcon: PropTypes.node,
    secondaryButtonText: PropTypes.string,
    secondaryButtonVariant: PropTypes.string
  })
};
